/** @format */

// plugins/dirPlugin.js

import Vue from 'vue';
import DirSyncManager from '@/services/dirSyncManager';

export default {
  install(_Vue, { store }) {
    const getAxios = () => Vue.prototype.$axios;

    const sync = new DirSyncManager({
      store,
      axios: getAxios(),
      refreshDir: async (dir) => {
        await store.dispatch('dirs/refresh', {
          name: dir,
          axios: getAxios(),
        });
      },
    });

    Vue.prototype.$dir = {
      get(name) {
        store.commit('dirs/MARK_USED', name);
        const data = store.getters['dirs/get'](name);
        const loaded = store.getters['dirs/isLoaded'](name);
        if (!loaded) {
          store.dispatch('dirs/load', {
            name,
            axios: getAxios(),
          });
        }

        return data;
      },

      refresh(name) {
        return store.dispatch('dirs/refresh', { name, axios: getAxios() });
      },
      notifyUpdate(dir, id = null, item = null) {
        if (!dir) return;

        if (item) {
          this.sync.broadcastPatch(dir, item);
          return;
        }

        this.sync.onSocketMessage({
          type: 'dir_update',
          dir,
          id,
        });
      },

      sync,
    };
  },
};
